<div class="dialog-container">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <mat-dialog-content>
    <p>
      {{ data.bodyText }}
    </p>
  </mat-dialog-content>
  <mat-dialog-actions [align]="'end'">
    <button
      mat-button
      [mat-dialog-close]="data.returnValue"
      (click)="data.onConfirm ? data.onConfirm() : null"
      mat-dialog-close
    >
      OK
    </button>
  </mat-dialog-actions>
</div>
